import { newTabLinkProps } from './newTabLinkProps'

export const windowOpenArgs = [newTabLinkProps.target, newTabLinkProps.rel.replace(' ', ',')] as const
